<div class="container">
    <div class="header">
        <app-button
            class="new-button"
            text="system-settings.eap.add-button.text"
            [iconButton]="true"
            [noneMarginIcon]="true"
            iconSize="20px"
            icon="plus"
            [disable]="eapList?.length >= EAP_MAX || !canEditSettings"
            (onClick)="createEapSetting()"
            customFontSize="14px"
            customFontFamily="NotoSans-SemiBold"></app-button>
        <span class="description">
            {{
                (eapList?.length >= EAP_MAX ? 'system-settings.eap.limit-reached' : 'system-settings.eap.description')
                    | translate: { num: EAP_MAX - eapList?.length || 0 }
            }}
        </span>
    </div>
    <div class="table" *ngIf="eapList.length">
        <div class="row table-header">
            <div class="cell table-header">
                {{ 'system-settings.eap.table-header.eap' | translate }}
            </div>
            <div class="cell table-header">
                {{ 'system-settings.eap.table-header.location' | translate }}
            </div>
            <div class="cell table-header">
                {{ 'system-settings.eap.table-header.screen-display' | translate }}
            </div>
            <div class="cell table-header error-icon-wrapper">
                <div
                    #errorsContainer
                    *ngIf="getEmptyErrors() > 0"
                    (click)="showErrors = !showErrors; $event.stopPropagation()">
                    <mat-icon svgIcon="save-error" class="error-icon" />
                    <div class="error-message" *ngIf="showErrors">
                        <div>
                            {{
                                'system-settings.eap.error.location.empty.' + (getEmptyErrors() === 1 ? 'one' : 'other')
                                    | translate
                            }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngFor="let eap of eapList; let i = index" [class.disabled]="!canEditSettings">
            <div class="cell eap-number" data-cy="ops-settings-system-setting-eap-number">
                {{ i + 1 }}
            </div>
            <div class="cell">
                <div class="location-wrapper">
                    <mat-icon svgIcon="location"></mat-icon>
                    <app-system-setting-input
                        [name]="LOCATION"
                        label="system-settings.eap.dialog.input-placeholder.location"
                        [value]="eap.location"
                        (onInputChange)="onInputChange($event, eap, i)"
                        (onBlur)="onInputBlur(eap, i)"
                        [inputErrorMessage]="validationErrors[i]?.location?.message"
                        [showErrorMessage]="false"
                        [maxLength]="getCharacterLimit()">
                    </app-system-setting-input>
                </div>
            </div>
            <div class="cell">
                <div class="screen-display-wrapper">
                    <mat-icon class="display-icon" svgIcon="desktop_windows"></mat-icon>
                    <app-system-setting-dropdown
                        [name]="SCREEN_DISPLAY"
                        [itemList]="displays"
                        [value]="eap.screenDisplay"
                        [isDropdownBelow]="true"
                        (onInputChange)="onInputChange($event, eap, i)"
                        class="input-wrapper">
                    </app-system-setting-dropdown>
                </div>
            </div>
            <div
                class="cell options"
                [class.selected]="isOpenOption && selectedIndex === i"
                (click)="openMoreOption(i); $event.stopImmediatePropagation()">
                <mat-icon
                    class="more-icon"
                    data-cy="ops-settings-system-setting-eap-kebab-icon"
                    svgIcon="more-options"></mat-icon>
                <div class="options-dialog" [class.show]="isOpenOption && selectedIndex === i">
                    <div
                        class="options-item"
                        [class.disabled]="eapList?.length >= EAP_MAX"
                        (click)="duplicateEap($event)">
                        {{ 'system-settings.eap.more-option.duplicate' | translate }}
                    </div>
                    <div class="options-item" (click)="deleteEap($event)">
                        {{ 'system-settings.eap.more-option.delete' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-confirmation-window
    #cancelConfirmation
    [mainLabel]="'system-settings.eap.cancel.dialog.title'"
    [discardLabel]="'system-settings.eap.cancel.dialog.discard'"
    [goBackLabel]="'system-settings.eap.cancel.dialog.go-back'"
    [saveLabel]="'system-settings.eap.cancel.dialog.save'"></app-confirmation-window>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>
